import { render, staticRenderFns } from "./i4pro-group-buttons.vue?vue&type=template&id=128247ad&scoped=true"
import script from "./i4pro-group-buttons.vue?vue&type=script&lang=js"
export * from "./i4pro-group-buttons.vue?vue&type=script&lang=js"
import style0 from "./i4pro-group-buttons.vue?vue&type=style&index=0&id=128247ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128247ad",
  null
  
)

export default component.exports